import PropTypes from 'prop-types';
import React from 'react';
import FilterBase from './FilterBase';
import CheckboxInput from 'components/connectedForm/CheckboxInput';
import styles from 'styles/partials/_filterboolean.css';

export default class FilterBoolean extends FilterBase {
  constructor(props) {
    super(props);

    const { yes, no, ...rest } = this.state.filterValues;

    this.state = Object.assign({}, this.state, {
      filterValues: {
        ...rest,
        yes: yes ?? !(props.fieldName === 'template' || props.fieldName === 'archived'),
        no: no ?? true,
      },
    });

    this.getDescription = this.getDescription.bind(this);
    this.getQueryFilters = this.getQueryFilters.bind(this);
    this.handleChangeEvent = this.handleChangeEvent.bind(this);
    this.checkValid = this.checkValid.bind(this);
    this.renderPopout = this.renderPopout.bind(this);
  }

  getDescription() {
    if (this.committedValues.yes) {
      return this.committedValues.no ? 'All' : 'Yes';
    }
    return 'no';
  }

  getQueryFilters() {
    if (this.state.filterValues.yes && this.state.filterValues.no) {
      if (this.props.fieldName === 'template' || this.props.fieldName === 'archived') {
        return [
          {
            fieldName: this.props.fieldName,
            operation: '=',
            value: true,
          },
          {
            fieldName: this.props.fieldName,
            operation: '=',
            value: false,
          },
        ];
      }
      return [];
    }
    let value = this.state.filterValues.yes;
    return [
      {
        fieldName: this.props.fieldName,
        operation: '=',
        value: value,
      },
    ];
  }

  handleChangeEvent(id, event) {
    let value = event.target.checked;
    this.handleChange(id, value);
  }

  checkValid() {
    if (!this.state.filterValues.yes && !this.state.filterValues.no) {
      return 'You must select at least one of the filter options (yes or no)';
    }
    return null;
  }

  renderPopout() {
    return (
      <div className={styles['container']}>
        <div className={styles['checkbox']}>
          <CheckboxInput
            id="yes"
            value={this.state.filterValues.yes}
            label="yes"
            onChange={e => this.handleChangeEvent('yes', e)}
            setInputRef={this.setInputRef}
          />
        </div>
        <div className={styles['checkbox']}>
          <CheckboxInput
            id="no"
            value={this.state.filterValues.no}
            label="no"
            onChange={e => this.handleChangeEvent('no', e)}
          />
        </div>
      </div>
    );
  }
}

FilterBoolean.propTypes = {
  yes: PropTypes.bool,
  no: PropTypes.bool,
};
